import { isReplayAstrHeader } from 'asteroids-shared/ReplayBinary'

const jsonHeaders = {
  'content-type': 'application/json; charset=utf-8'
}

async function readError(response) {
  try {
    const body = await response.json()
    return body?.error || body?.message || `http_${response.status}`
  } catch {
    return `http_${response.status}`
  }
}

async function throwIfNotOk(response) {
  if (response.ok) return
  const error = new Error(await readError(response))
  error.status = response.status
  throw error
}

async function readJson(response) {
  await throwIfNotOk(response)
  return response.json()
}

async function readReplayBody(response) {
  await throwIfNotOk(response)
  const buf = await response.arrayBuffer()
  if (isReplayAstrHeader(new Uint8Array(buf))) return buf
  throw new Error('replay_invalid_binary')
}

export async function listRooms() {
  const response = await fetch('/api/rooms', {
    headers: { 'cache-control': 'no-store' }
  })

  return readJson(response)
}

export async function listHighScores(mode = 'all') {
  const url = new URL('/api/high-scores', window.location.origin)
  if (mode && mode !== 'all') url.searchParams.set('mode', mode)
  const response = await fetch(url, {
    headers: { 'cache-control': 'no-store' }
  })

  return readJson(response)
}

export async function createRoom(roomName, isPrivate, toroidalMap = true) {
  const response = await fetch('/api/rooms', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ roomName, isPrivate, toroidalMap })
  })

  return readJson(response)
}

export async function prepareJoin(roomId, roomCode = '') {
  const response = await fetch(`/api/rooms/${encodeURIComponent(roomId)}/join`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ roomCode })
  })

  return readJson(response)
}

export async function fetchReplayBlob(replayId) {
  const response = await fetch(`/api/replays/${encodeURIComponent(replayId)}`, {
    headers: { 'cache-control': 'no-store' }
  })
  return readReplayBody(response)
}
